import { useState } from 'react';
import { ScreeningToolResponseCreateProps } from '../types/ScreeningToolResponse';
import { ScreeningToolResponseType } from '../types/ScreeningToolResponse';

interface UseCreateScreeningToolResponseResult {
  submitResponse: (data: ScreeningToolResponseCreateProps) => Promise<submitCreateScreeningToolResponseType>;
  loading: boolean;
  error: string | null;
}

interface submitCreateScreeningToolResponseType {
  data: ScreeningToolResponseType;
  errors?: Record<string, string[]>;
}

export function useCreateScreeningToolResponse(): UseCreateScreeningToolResponseResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitResponse = async (data: ScreeningToolResponseCreateProps): Promise<submitCreateScreeningToolResponseType> => {
    setLoading(true);
    setError(null);
    try {
      // Get CSRF token from meta tag (Rails default)
      const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      const response = await fetch('/screening/screening_tool_response', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(token ? { 'X-CSRF-Token': token } : {}),
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (!response.ok) {
        setError('Failed to submit response');
        setLoading(false);
        return { errors: { base: ['Failed to submit response'] } as Record<string, string[]> } as submitCreateScreeningToolResponseType;
      }

      setLoading(false);
      return { data: responseData } as submitCreateScreeningToolResponseType;
    } catch (err) {
      console.log('Errors faced')
      setError('Failed to submit response');
      setLoading(false);
      return { errors: { base: ['Failed to submit response'] } as Record<string, string[]> } as submitCreateScreeningToolResponseType;
    }
  };

  return { submitResponse, loading, error };
}
